import { createContext } from 'react';
import { SettingsSection } from 'shared/dialogs/user-settings/settings-nav';

export type UserSettingsContextProps = {
  // absent = open on the default section; a target section is threaded to the form's
  // initial activeSection rather than encoded in a route
  openSettings: (section?: SettingsSection) => void;
  openChangePassword: () => void;
};

export const UserSettingsContext = createContext<UserSettingsContextProps>({
  openSettings: () => {},
  openChangePassword: () => {},
});
